import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';
import { AdminManagerService } from '../../services/admin-manager.service';

// TODO: Update userTypeLookupId with the actual lookup ID once database metadata is generated.
const USER_TYPE_LOOKUP_ID = 0;

@DwComponent({
  key: 'sc-set-user-type',
  name: 'Set User Type',
  isGlobal: true,
  componentType: DwComponentType.menuComponent
})
@Component({
  selector: 'app-set-user-type',
  template: `
    <div class="dropdown-item2" style="padding:10px" *ngIf="canSetUserType">
         Set User Type

           <dw-radio-lookup [(ngModel)]="adminUserTypeId" (ngModelChange)="onMenuClick($event)"
                [lookupId]="userTypeLookupId"></dw-radio-lookup>
    </div>
  `
})
export class UserTypeMenuComponent implements OnInit {
  userTypeLookupId = USER_TYPE_LOOKUP_ID;
  adminUserTypeId: any;
  canSetUserType: boolean;

  constructor(private adminManagerService: AdminManagerService) { }

  ngOnInit(): void {
    this.canSetUserType = this.adminManagerService.canUseAdminProperties();

    const user = this.adminManagerService.getFitnessUser();

    this.adminUserTypeId = user.UserTypeId;
  }

  onMenuClick(event: any) {
    this.adminManagerService.updateAdminProperties({
      userTypeMode: this.adminUserTypeId
    });
  }
}
